import React from 'react'
import Avatar from '../avatar/Avatar'
import { getColorByIndex } from '../../../utils/colors.helper'
import { Flex } from 'antd'
import Text from 'antd/es/typography/Text'

const User = ({ id, name, email, size }) => {
    return (
        <Flex gap={8} align='center'>
            <Avatar name={name} color={getColorByIndex(id).value} size={size} />
            <Flex vertical>
                {name && <Text>{name}</Text>}
                {email && <Text type={'secondary'}>{email}</Text>}
            </Flex>
        </Flex>
    )
}

export default User
